export default __webpack_public_path__ + "static/media/icon-frutta-pane-marmellata.ae79cb73.svg";